module.exports = __webpack_public_path__ + "img/C5A292_635247_F2D7D6_846A5B-256px.c734fee0.png";